export enum LOAN_STATE_ENUM {
  SINISTERED_RAPIPLAZO = 'SINISTERED_RAPIPLAZO',
  ON_GRAY_ZONE_PROCESS_RAPIPLAZO = 'ON_GRAY_ZONE_PROCESS_RAPIPLAZO',
  DISBURSED_RAPIPLAZO = 'DISBURSED_RAPIPLAZO',
  ON_GRAY_ZONE_PROCESS_RAPIPLAZO_EXP_DATE = 'ON_GRAY_ZONE_PROCESS_RAPIPLAZO_EXP_DATE',
  DISBURSE_PENDING_RAPIPLAZO = 'DISBURSE_PENDING_RAPIPLAZO',
  DISBURSE_ON_PROCESS_RAPIPLAZO = 'DISBURSE_ON_PROCESS_RAPIPLAZO',
  PAY_DELAY_RAPIPLAZO = 'PAY_DELAY_RAPIPLAZO',
  ON_GRAY_ZONE_PROCESS_RAPIPLAZO_ACC = 'ON_GRAY_ZONE_PROCESS_RAPIPLAZO_ACC',
  PENDING_SIGNATURE_RAPIPLAZO = 'PENDING_SIGNATURE_RAPIPLAZO',
  PREPAYED_RAPIPLAZO = 'PREPAYED_RAPIPLAZO',
  NOVATED_PENDING_RAPICREDITO = 'NOVATED_PENDING_RAPICREDITO',
}
